import React from "react";
import { IconT } from "types/utils";

const FunnelOutlineIcon = ({ height = "10", width = "10", fill = "currentColor" }: IconT) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 20 20" fill="none" aria-hidden>
      <path
        d="M3 5h14l-5.5 6.5V17l-3 1.5v-7z"
        stroke={fill}
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default FunnelOutlineIcon;
